<template>
    <section class="search-results results">
        <div class="container">
            <transition-group name="list">
                <SearchResultsItem 
                    v-for="(item, index) in items" 
                    :key="index"
                    :item="item">
                </SearchResultsItem>
            </transition-group>
        </div>

        <Pagination 
            v-if="isPagination"
            :name="name"
            :itemsPage="itemsPage"
            :itemsPerPage="itemsPerPage" 
            :itemsTotalCount="totalCount">
        </Pagination>
    </section>
</template>

<script>
import SearchResultsItem from "./SearchResultsItem.vue";
import Pagination from "../elements/Pagination.vue";

export default {
    name: "SearchResults",
    components: {
        SearchResultsItem,
        Pagination
    },
    props: {
        searchList: {
            type: Object,
            default: () => {},
        },
        itemsPerPage: {
            type: Number,
            default: 10
        },
        itemsPage: {
            type: Number
        }
    },
    computed: {
        items() {
            return this.searchList.items;
        },
        totalCount() {
            return this.searchList.total_count;
        },
        isPagination() {
            if(this.totalCount && this.totalCount > this.itemsPerPage) {
                return true;
            } 
            return false;
        },
        name() {
            if(this.$route && this.$route.name) {
                return this.$route.name
            }
            return null;
        },
    }
};
</script>